<template>
	<div>
		<!-- Header  -->
		<div class="unit-title">
			<h3 class="font-weight-regular mb-0 white--text">
				What departments, initiatives and organisations are in the Etisalat
				eco-system?
			</h3>
			<p>Click the + to add a department</p>
			<v-btn @click="add" class="ma-1 white" fab small light>
				<v-icon>mdi-plus</v-icon></v-btn
			>
		</div>
		<v-btn @click="toggleCompact" class="ma-1 black white--text" light>{{
			compactText
		}}</v-btn>
		<!-- Content  -->
		<v-row>
			<draggable
				class="inner mt-5"
				:list="items"
				group="order"
				@start="startDrag()"
				@end="endDrag()"
				:ref="name"
				:id="name"
			>
				<v-col
					cols="12"
					v-for="(item, index) in items"
					:key="`unit-${index}`"
					:data-id="`${Math.round(new Date().getTime() / 1000)}`"
				>
					<brand-architecture-card
						:item="item"
						@edit="edit"
						@remove="remove"
						@show="show"
						:index="item.index"
						:mode="mode"
					/>
				</v-col>
			</draggable>
		</v-row>
		<!-- Dialog -->
		<v-dialog v-model="dialog" max-width="980">
			<v-card v-if="dialogMode === 'delete'" light>
				<v-card-title>
					Are you sure you want to delete this item?
				</v-card-title>
				<v-card-text class="">
					<v-btn light color="amber mr-5" class="" @click="removeItem"
						>Delete</v-btn
					>
					<v-btn light color="white" class="" @click="cancel">Cancel</v-btn>
				</v-card-text>
			</v-card>
			<v-card light v-else-if="dialogMode === 'show'">
				<brand-architecture-card :item="item" :controls="false" />

				<v-btn light color="white" class="mt-10 mr-2" @click="cancel"
					>Close</v-btn
				>
			</v-card>
			<v-card light v-else-if="dialogMode === 'edit'">
				<brand-architecture-form v-model="item" title="Edit an item">
					<v-btn light color="green" class="mt-10 mr-2" @click="editItem"
						>Update</v-btn
					>
					<v-btn light color="white" class="mt-10 mr-2" @click="cancel"
						>Cancel</v-btn
					>
				</brand-architecture-form>
			</v-card>
			<v-card light v-else>
				<v-card-text class="">
					<brand-architecture-form v-model="item" title="Add an item">
						<v-btn light color="green" class="mt-10 mt-2 mr-2" @click="addItem"
							>Create Attribute</v-btn
						>
						<v-btn light color="white" class="mt-10 mt-2 mr-2" @click="cancel"
							>Cancel</v-btn
						>
					</brand-architecture-form>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import ArchitectureMixin from './ArchitectureMixin';
import BrandArchitectureForm from './BrandArchitectureForm';
import BrandArchitectureCard from './BrandArchitectureCard';
import draggable from 'vuedraggable';

export default {
	name: 'BrandArchitectureStep1',
	mixins: [ArchitectureMixin],
	data() {
		return {
			items: this.value,
			name: 'steps',
			compact: false,
		};
	},
	props: {
		value: Array,
	},
	watch: {
		value: {
			handler: function(val) {
				this.items = val;
			},
			deep: true,
		},
	},
	components: {
		BrandArchitectureForm,
		BrandArchitectureCard,
		draggable,
	},
	computed: {
		mode() {
			return this.compact ? 'compact' : 'full';
		},
		compactText() {
			return this.compact ? 'Expand' : 'Compact';
		},
	},
	methods: {
		toggleCompact() {
			this.compact = !this.compact;
		},
		startDrag() {
			this.dragging = true;
		},
		endDrag() {
			let count = 0;
			let vm = this;
			let div = document.getElementById(this.name);
			div.children.forEach((doc) => {
				let item = this.items.find((x) => x.id == doc.dataset.id);
				if (item) {
					let indexOfItem = this.items.indexOf(item);
					item.index = count;
					vm.$set(vm.items, indexOfItem, item);
				}
				count++;
			});
			this.dragging = false;
		},
	},
};
</script>

<style lang="scss" scoped>
.inner {
	width: 100%;
}
.unit-items {
	.item {
		&--flex {
			display: flex;
			justify-content: space-between;
			align-items: flex-start;
		}
		padding: 0.5rem;
		margin: 0.5rem 0;
		background: white;
		border-radius: 5px;
		color: black;
		.icons {
			width: 50px;
			padding: 0 10px 0 10px;
			display: flex;
		}
	}
}
.unit-title {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
}
.add-button {
	margin: 0 !important;
	position: relative;
	right: 0;
}
.unit-field {
	margin: 0.75rem 0 !important;
}
.no-bullets {
	list-style: none;
	margin: 0;
	padding: 0 0 0px 5px;
	li {
		padding: 5px 0;
		border-bottom: dotted 1px #333;
	}
}
</style>
